// Pinia store: formData (migration from Vuex module)
import { defineStore } from 'pinia'

// Helper
const loopClearNestedObj = (obj) => {
  Object.keys(obj).forEach(key => {
    if (obj[key] && typeof obj[key] === 'object') {
      loopClearNestedObj(obj[key])
    } else {
      obj[key] = undefined
    }
  })
}

export const useFormDataStore = defineStore('formData', {
  state: () => ({
    status: undefined,
    message: undefined,
    sessionKey: '',
    formData: {
      lastName: undefined,
      userId: undefined,
      streetNumber: undefined,
      cellPhone: undefined,
      personalEmail: undefined,
      username: undefined,
      emailAddress: undefined,
      employeeId: undefined,
      validationDevices: undefined,
      methodValue: undefined,
      selected: undefined,
      resetCode: undefined
    }
  }),
  getters: {
    getSessionKey: (state) => state.sessionKey,
    getFormDataLastName: (state) => state.formData.lastName,
    getFormDataUserId: (state) => state.formData.userId,
    getFormDataStreetNumber: (state) => state.formData.streetNumber,
    getFormDataStatus: (state) => state.status,
    getFormDataMessage: (state) => state.message,
    getFormDataCellPhone: (state) => state.formData.cellPhone,
    getFormDataPersonalEmail: (state) => state.formData.personalEmail,
    getFormDataUsername: (state) => state.formData.username,
    getFormDataEmailAddress: (state) => state.formData.emailAddress,
    getFormDataEmployeeId: (state) => state.formData.employeeId,
    getValidationDevices: (state) => state.formData.validationDevices,
    getMethodValue: (state) => state.formData.methodValue,
    getSelected: (state) => state.formData.selected
  },
  actions: {
    clearData () {
      loopClearNestedObj(this.formData)
    },
    setSessionKey (sessionKeyIn) {
      this.sessionKey = sessionKeyIn
    },
    updateStatus (status) { this.status = status },
    updateMessage (message) { this.message = message },
    updateFormDataLastName (lastName) { this.formData.lastName = lastName },
    updateFormDataStreetNumber (streetNumber) { this.formData.streetNumber = streetNumber },
    updateFormDataCellPhone (cellPhone) { this.formData.cellPhone = cellPhone },
    updateFormDataUserId (userId) {
      if (userId && userId.indexOf('@') > -1) {
        userId = userId.substring(0, userId.indexOf('@'))
      }
      this.formData.userId = userId
    },
    updateFormDataPersonalEmail (personalEmail) { this.formData.personalEmail = personalEmail },
    updateFormDataUsername (username) {
      if (username && username.indexOf('@') > -1) {
        username = username.substring(0, username.indexOf('@'))
      }
      this.formData.username = username
    },
    updateFormDataEmailAddress (emailAddress) { this.formData.emailAddress = emailAddress },
    updateFormDataEmployeeId (employeeId) { this.formData.employeeId = employeeId },
    updateValidationDevices (validationDevices) { this.formData.validationDevices = validationDevices },
    updateMethodValue (methodValue) { this.formData.methodValue = methodValue },
    updateSelected (selected) { this.formData.selected = selected },
    updateResetCode (resetCode) { this.formData.resetCode = resetCode }
  }
})
